// extracted by mini-css-extract-plugin
export default {"container":"payment_container__WVGV7","info":"payment_info__EmDBt","icon":"payment_icon__BjDmW","highlight":"payment_highlight__5diNs","pulse":"payment_pulse__4QVNO"};